import { Component, OnInit, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';

@Component({
    selector: 'hq-product-thumbnail',
    templateUrl: './product-thumbnail.component.html',
    styleUrls: ['./product-thumbnail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductThumbnailComponent implements OnInit {
    @Input() url: string;
    @Input() width = '75px';
    @Input() height = '75px';

    @HostBinding('style.--thumbnail-width')
    get thumbnailWidth() {
        return this.width;
    }

    @HostBinding('style.--thumbnail-height')
    get thumbnailHeight() {
        return this.height;
    }

    hasProductImage = false;
    fullUrl: string;
    private hasLoaded = false;

    ngOnInit(): void {
        if (this.url) {
            this.fullUrl = this.url;
            this.hasProductImage = true;
        }
        this.hasLoaded = true;
    }

    onFailToLoad(event: ErrorEvent): void {
        if (this.hasLoaded) {
            this.hasProductImage = false;
        }
    }
}
